// tslint:disable: naming-convention
import { Action } from '@ngrx/store';
import { ContractOptionsEntity } from '../../../entities/mdqx/contract-options.entity';
import {
    MutationChangeContractoptionsArgs,
    MutationCreateContractoptionsArgs,
    MutationDeleteContractoptionsArgs,
} from '../../../mdqx-graphql-types';

export enum ContractOptionsActionTypes {
    GetContractOptionsRequest = '[ContractOptions] Get Request',
    GetContractOptionsResponse = '[ContractOptions] Get Response',
    PostContractOptionsRequest = '[ContractOptions] Post Request',
    PostContractOptionsResponse = '[ContractOptions] Post Response',
    PatchContractOptionsRequest = '[ContractOptions] Patch Request',
    PatchContractOptionsResponse = '[ContractOptions] Patch Response',
    DeleteContractOptionsRequest = '[ContractOptions] Delete Request',
    DeleteContractOptionsResponse = '[ContractOptions] Delete Response',
}

export class GetContractOptionsRequest implements Action {
    readonly type = ContractOptionsActionTypes.GetContractOptionsRequest;
}

export class GetContractOptionsResponse implements Action {
    readonly type = ContractOptionsActionTypes.GetContractOptionsResponse;
    constructor(public Payload: ContractOptionsEntity[]) {}
}

export class PostContractOptionsRequest implements Action {
    readonly type = ContractOptionsActionTypes.PostContractOptionsRequest;
    constructor(public Payload: MutationCreateContractoptionsArgs) {}
}

export class PostContractOptionsResponse implements Action {
    readonly type = ContractOptionsActionTypes.PostContractOptionsResponse;
    constructor(public Payload: ContractOptionsEntity) {}
}

export class PatchContractOptionsRequest implements Action {
    readonly type = ContractOptionsActionTypes.PatchContractOptionsRequest;
    constructor(public Payload: MutationChangeContractoptionsArgs) {}
}

export class PatchContractOptionsResponse implements Action {
    readonly type = ContractOptionsActionTypes.PatchContractOptionsResponse;
    constructor(public Payload: ContractOptionsEntity) {}
}

export class DeleteContractOptionsRequest implements Action {
    readonly type = ContractOptionsActionTypes.DeleteContractOptionsRequest;
    constructor(public Payload: MutationDeleteContractoptionsArgs) {}
}

export class DeleteContractOptionsResponse implements Action {
    readonly type = ContractOptionsActionTypes.DeleteContractOptionsResponse;
    constructor(public Payload: number) {}
}

export type ContractOptionsActions =
    | GetContractOptionsRequest
    | GetContractOptionsResponse
    | PostContractOptionsRequest
    | PostContractOptionsResponse
    | PatchContractOptionsRequest
    | PatchContractOptionsResponse
    | DeleteContractOptionsRequest
    | DeleteContractOptionsResponse;
